"use strict";
import { jsx } from "react/jsx-runtime";
import React from "react";
import Api from "../api/api";
import { History } from "react-router";
var RootPage = React.createClass({
  mixins: [History],
  componentWillMount: function() {
    if (Api.Account.current().scraper_account && Api.Account.current().payables_account) {
      this.history.pushState(null, "/dashboard");
    } else if (Api.Account.current().scraper_account) {
      this.history.pushState(null, "/to_be_scraped_loads");
    } else {
      this.history.pushState(null, "/dashboard");
    }
  },
  render: function() {
    return /* @__PURE__ */ jsx("span", { "data-component": "RootPage" });
  }
});
export default RootPage;
